module.exports = __webpack_public_path__ + "hbomaxar-static/media/LiquidTrip_Small.f7f5b0f1.png";